import angular from "angular";

import { vsModuleName as configModuleName } from "./configs/module";
import { vsModuleName as sharedModuleName } from "../shared";
import {
  SycuanMachinesComponentsViewsMain,
  vsComponentName as SycuanMachinesComponentsViewsMainName,
} from "./components/views/main/component";
import { routeConfig } from "./routes";
import {
  MachineConfigurationEditFormComponentOptions,
  vsComponentName as MachineConfigurationEditFormComponentName,
} from "./components/machineEditForm";
import {
  CloneAndConversionServiceSycuan,
  vsServiceName as CloneAndConversionServiceSycuanName,
} from "./services/cloneAndConversionService";
import {
  MachineConfigurationViewDetailComponentOptions,
  vsComponentName as MachineConfigurationViewComponentName,
} from "./components/machineConfigurationDetailView/component";
import {
  machinesMoveViewComponentOptions,
  vsComponentName as machinesMoveViewComponentName,
} from "./components/views/main/move";
import {
  machinesWarehouseMoveViewComponentOptions,
  vsComponentName as machinesWarehouseMoveViewComponentName,
} from "./components/views/main/warehouse";
import {
  machinesDecommissionMoveViewComponentOptions,
  vsComponentName as machinesDecommissionMoveViewComponentName,
} from "./components/views/main/decommission";
import {
  singleMachineMoveComponentOptions,
  vsComponentName as singleMachineMoveComponentName,
} from "./components/views/detail/move/component";
import {
  singleMachineWarehouseComponentOptions,
  vsComponentName as singleMachineWarehouseComponentName,
} from "./components/views/detail/warehouse";
import {
  singleMachineDecommissionComponentOptions,
  vsComponentName as singleMachineDecommissionComponentName,
} from "./components/views/detail/decommission";
import {
  SlotTrakServerAdapter,
  vsName as SlotTrakServerAdapterName,
} from "./slotTrakServerAdapter";

import { vsName as depreciationModuleName } from "../../Depreciation";

import { vsModuleName as partsMachinesModuleName } from "../../parts.machines/module";
import { vsModuleName as mealLogSycuanModuleName } from "./mealLog";

import {
  vsComponentName as softwareProgramGridComponentName,
  softwareProgramGridComponentOptions,
} from "./components/softwareProgramGrid";

import { vsModuleName as processModuleName } from "./processes/module";
import { default as applicationModuleName } from "../../application";

export const vsModuleName = "SlotTrak.Machines";
export const vsClientName = "sycuan";
export default vsModuleName;

angular
  .module(vsModuleName, [
    configModuleName,
    sharedModuleName,
    partsMachinesModuleName,
    depreciationModuleName,
    processModuleName,
    mealLogSycuanModuleName,
    applicationModuleName
  ])
  .constant("clientName", vsClientName)
  .config(routeConfig)
  .component(
    SycuanMachinesComponentsViewsMainName,
    SycuanMachinesComponentsViewsMain
  )
  .component(
    MachineConfigurationEditFormComponentName,
    MachineConfigurationEditFormComponentOptions
  )
  .component(
    MachineConfigurationViewComponentName,
    MachineConfigurationViewDetailComponentOptions
  )
  .service(CloneAndConversionServiceSycuanName, CloneAndConversionServiceSycuan)
  .component(machinesMoveViewComponentName, machinesMoveViewComponentOptions)
  .component(
    machinesWarehouseMoveViewComponentName,
    machinesWarehouseMoveViewComponentOptions
  )
  .component(
    machinesDecommissionMoveViewComponentName,
    machinesDecommissionMoveViewComponentOptions
  )
  .component(singleMachineMoveComponentName, singleMachineMoveComponentOptions)
  .component(
    singleMachineWarehouseComponentName,
    singleMachineWarehouseComponentOptions
  )
  .component(
    singleMachineDecommissionComponentName,
    singleMachineDecommissionComponentOptions
  )
  .component(
    softwareProgramGridComponentName,
    softwareProgramGridComponentOptions
  )
  .service(SlotTrakServerAdapterName, SlotTrakServerAdapter);
